import type { SilobagRow } from './types';

const UTILS = {
  extract: {
    tag: {
      system: extractSystemTag,
      vri: extractVriTag,
    },
    level: {
      vri: getVriLevel,
    },
  },
  is: {
    vrr: {
      ok: (tag: TagWithLabel) => tag.label.endsWith('_GREEN'),
      not_ok: (tag: TagWithLabel) => tag.label.endsWith('_RED'),
    },
    vri: {
      approved: (tag: TagWithLabel) => getVriStatus(tag) === 'approved',
      rejected: (tag: TagWithLabel) => getVriStatus(tag) === 'rejected',
      pending: (tag: TagWithLabel) => getVriStatus(tag) === 'pending',
    },
    tag: {
      insurance: {
        active: (tag: TagWithLabel) => ['INSURANCE_CREATED', 'INSURANCE_UPDATED'].includes(tag.label),
        expired: (tag: TagWithLabel) => ['INSURANCE_EXPIRED'].includes(tag.label),
      },
      warranty: {
        active: (tag: TagWithLabel) => ['WARRANT_CREATED', 'WARRANT_UPDATED'].includes(tag.label),
        expired: (tag: TagWithLabel) => ['WARRANT_EXPIRED'].includes(tag.label),
      },
    },
  },
  has: {
    tag: {
      insurance: {
        active: (row: SilobagRow) => row.tags_silobags.some((t) => UTILS.is.tag.insurance.active(t.tag)),
        expired: (row: SilobagRow) => row.tags_silobags.some((t) => UTILS.is.tag.insurance.expired(t.tag)),
      },
      warranty: {
        active: (row: SilobagRow) => row.tags_silobags.some((t) => UTILS.is.tag.warranty.active(t.tag)),
        expired: (row: SilobagRow) => row.tags_silobags.some((t) => UTILS.is.tag.warranty.expired(t.tag)),
      },
    },
  },
};

export default UTILS;

type SilobagTag = SilobagRow['tags_silobags'][number]['tag'];
type TagWithLabel = Pick<SilobagTag, 'label'>;
type VriStatus = 'approved' | 'rejected' | 'pending';
type VriLevel = 1 | 2 | 3;

const VRI_LABEL_PATTERN = /^VRI_L([1-3])(?:_(OK|RECHAZADA))?$/;

function extractSystemTag(row: SilobagRow, match?: (tag: TagWithLabel) => boolean): SilobagTag | null {
  return (
    row.tags_silobags.find((t) => t.tag.scope.value === 'system' && (!match || match(t.tag)))?.tag ?? null
  );
}

function extractVriTag(row: SilobagRow): SilobagTag | null {
  return (
    row.tags_silobags.find(({ tag }) => tag.scope.value === 'system' && getVriStatus(tag) !== null)?.tag ??
    null
  );
}

function getVriStatus(tag: TagWithLabel): VriStatus | null {
  const match = VRI_LABEL_PATTERN.exec(tag.label);
  if (!match) return null;
  if (match[2] === 'OK') return 'approved';
  if (match[2] === 'RECHAZADA') return 'rejected';
  return 'pending';
}

function getVriLevel(tag: TagWithLabel): VriLevel | null {
  const level = VRI_LABEL_PATTERN.exec(tag.label)?.[1];
  return level ? (Number(level) as VriLevel) : null;
}
